import React from 'react';
import PropTypes from 'prop-types';

import { Banner } from '@zola/zola-ui';
import UploadButton from '../../../form/FileInputZolaUIButton';

import exampleRows from '../../../../../assets/images/guestlist/example_spreadsheet.png';

import './UploadPane.styles.less';

// this component should match this one too:
// src/cards/components/Customization/steps/Recipients/UploadCsv/UploadCsv.jsx

const UploadPane = ({
  onFileSelect,
  uploadErrors
}) => {
  const hasErrors = uploadErrors.length > 0;
  return (
    <React.Fragment>
      {hasErrors && 
        uploadErrors.map(errorText => (
          <Banner type="error" text={errorText} key={errorText} />
        ))
      }
      <div className="upload-csv__tab">
        <p className="upload__intro">Follow the tips below, so we can seamlessly upload your spreadsheet.</p>
        <ul className="upload__list">
          <li className="upload__list-item"><i className="zolaicon zolaicon-checkmark" />Enter column headers (eg. Name, Plus One, Street Address) in the first row.</li>
          <li className="upload__list-item"><i className="zolaicon zolaicon-checkmark" />Enter guests and their plus ones or family members on the same line.</li>
          <li className="upload__list-item"><i className="zolaicon zolaicon-checkmark" />Split addresses into four columns: street address, city, state, and zip code.</li>
          <li className="upload__list-item"><i className="zolaicon zolaicon-checkmark" />Make sure your spreadsheet is a .csv file.</li>
        </ul>
        <img className="upload__example" src={exampleRows} alt="Example columns for a spreadsheet of guests" width="645" height="76"/>
        <UploadButton
          btnClass="upload__btn"
          busy={false}
          busyOverride
          divClass="upload__btn-container"
          inputId="csv-upload"
          types="text/csv"
          onSelect={file => onFileSelect(file)}
          btnText="Upload Spreadsheet"
        />
        <br />
        <p className="upload__help">Need help getting started? <a href="https://zola-web-assets.s3.amazonaws.com/web-wedding/Zola-Guest-Upload-Template.csv" download>We have a template for you.</a></p>
        <p className="upload__help">Still need help? <a href="mailto:planningtools@zola.com">Reach out</a> anytime or check out our <a target="_blank" rel="noopener noreferrer" href="https://help.zola.com/hc/en-us/articles/360038289992-How-do-I-add-guests-from-a-spreadsheet-to-my-guest-list-">FAQs</a>.</p>
      </div>
    </React.Fragment>
  );
};

UploadPane.propTypes = {
  onFileSelect: PropTypes.func,
  uploadErrors: PropTypes.arrayOf(PropTypes.string)
};

export default UploadPane;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/content/UploadPane.jsx